function Carousel( index, element, options ) {
    this.$element = $( element );
    this.index = index;
    
    this.selectors = {
      wrapper: ".carousel",
      slider: ".carousel__slides",
      items: ".carousel__item",
      image: ".carousel__item img"
    }

    this.states = {
      wrapper: {
        IS_INITIALIZED: "carousel--is-initialized"
      }
    }

    this.options = Object.assign( {}, {
      cellSelector: this.selectors.items,
      selectedAttraction: 0.2,
      friction: 0.8,
      groupCells: true,
      wrapAround: false,
      prevNextButtons: true,
      contain: true,
      cellAlign: "center",
      pageDots: false,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    }, options );

    this.mobileSettings = options.mobileSettings;

    // The additional margin that can be used whether to make the transition
    // to a slider sooner or later.
    this.viewportOffset = 0;


    this.initialize();
  }

Carousel.prototype = Object.assign( {}, Carousel.prototype, {
    initialize: function() {
      this.$wrapper = this.$element.find( this.selectors.wrapper );
      this.$slider = this.$element.find( this.selectors.slider );
      this.$items = this.$element.find( this.selectors.items );
      this.$image = this.$element.find( this.selectors.image );

      this.carouselInMobile = typeof this.$wrapper.data( "carousel-on-mobile" ) === "undefined" ? true : this.$wrapper.data( "carousel-on-mobile" );

      // If the wrapper cannot be found, check if the component itself is the carousel.
      if( !this.$wrapper.length && this.$element.hasClass( this.selectors.wrapper.replace( '.', '' ) ) ) 
        this.$wrapper = this.$element;

      // If window viewport changes, determine slider state and reset min-height.
      $( window )
      .on( "resize orientationchange", debounce( this.determineSliderState.bind( this ), 200 ) )
      .on( "orientationchange resize", this._handleResize.bind( this ) );

      this.$image.on( "load", () => $( window ).trigger( "resize" ) );

      // Determine slider state on initialization.
      this.determineSliderState();
    },

    isInitialized: function() {
      return this.$wrapper.hasClass( this.states.wrapper.IS_INITIALIZED );
    },

    initializeSlider: function() {
      let options = this.options;
      // If carousel is not yet initialized, initialize it.
      
      if( !this.carouselInMobile && $( window ).width() < 1024 )  {
        this.destroySlider(); 
        return;
      }

      if( !this.isInitialized() ) {
        // If on mobile, center the cells.
        if( $( window ).width() < 640 ) {
          console.log( "Carousel is using mobile options." );
          $.each(this.mobileSettings, (i,e) => {
            // options = Object.assign({}, options, {
            //   i: e
            // });
            options[i] = e;
          } );
          options = Object.assign( {}, options, {
            cellAlign: "center",
            freeScroll: false
          } );
        }

        // Initialize slider.
        this.$slider.flickity( options );

        this.$wrapper.addClass( this.states.wrapper.IS_INITIALIZED );
      }
    },

    destroySlider: function() {
      // Only destroy when Flickity is initialized.
      if( this.isInitialized() ) {
        this.$slider.flickity( "destroy" );

        this.$wrapper.removeClass( this.states.wrapper.IS_INITIALIZED );
      }
    },

    hasReachedViewportEdge: function() {
      // Get total width of items when combined.
      let totalWidth = 0;

      // Loop through the items to get the total width.
      this.$items.each( function() { 
        totalWidth += $( this ).outerWidth( true ); 
      } );
      
      // Check if the wrapper has reached the edges of the viewport.
      return ( totalWidth - this.viewportOffset ) >= this.$slider.width();
    },

    determineSliderState: function() {
      const hasReachedViewportEdge = this.hasReachedViewportEdge();

      // If the wrapper has reached the edge, turn the carousel into a slider.
      if( hasReachedViewportEdge ) {
        this.initializeSlider();

      // Else, destroy the slider.
      } else {
        this.destroySlider();
      }
    },

    refresh: function() {
      if( this.isInitialized() ) {
        this.$slider.flickity( "reloadCells" );
        this.$slider.flickity( "select", 0 );
      }
    },
    
    _handleResize: function( event ) {
      // When the window resizes, reset the min-height of the items;
      // then, trigger resize and revert to the min-height on the CSS.
      if( this.isInitialized() ) {
        this.$items.css( "min-height", "initial" );
        this.$slider.flickity( "resize" );
        this.$items.css( "min-height", '' );
      }
    },
} );